export default __webpack_public_path__ + "static/media/dashboard_participants.61c51cb6.svg";